/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIKeyCreated,
  APIKeyList,
  APIKeyRevoke,
  AvatarUpdated,
  ConnectedAccounts,
  CustomUser,
  MFAStatus,
  PaginatedCustomUserList,
  PatchedCustomUser,
  ProfileAction,
  ProfileDetails,
  ProfileUpdateError,
  ProfileUpdateRequest,
  ProfileUpdateResponse,
} from '../models/index';
import {
    APIKeyCreatedFromJSON,
    APIKeyCreatedToJSON,
    APIKeyListFromJSON,
    APIKeyListToJSON,
    APIKeyRevokeFromJSON,
    APIKeyRevokeToJSON,
    AvatarUpdatedFromJSON,
    AvatarUpdatedToJSON,
    ConnectedAccountsFromJSON,
    ConnectedAccountsToJSON,
    CustomUserFromJSON,
    CustomUserToJSON,
    MFAStatusFromJSON,
    MFAStatusToJSON,
    PaginatedCustomUserListFromJSON,
    PaginatedCustomUserListToJSON,
    PatchedCustomUserFromJSON,
    PatchedCustomUserToJSON,
    ProfileActionFromJSON,
    ProfileActionToJSON,
    ProfileDetailsFromJSON,
    ProfileDetailsToJSON,
    ProfileUpdateErrorFromJSON,
    ProfileUpdateErrorToJSON,
    ProfileUpdateRequestFromJSON,
    ProfileUpdateRequestToJSON,
    ProfileUpdateResponseFromJSON,
    ProfileUpdateResponseToJSON,
} from '../models/index';

export interface UsersAdminUsersListRequest {
    ordering?: string;
    page?: number;
    search?: string;
}

export interface UsersAdminUsersPartialUpdateRequest {
    id: number;
    patchedCustomUser?: Omit<PatchedCustomUser, 'id'|'avatar_url'|'get_display_name'|'has_usable_password'>;
}

export interface UsersAdminUsersRetrieveRequest {
    id: number;
}

export interface UsersAdminUsersUpdateRequest {
    id: number;
    customUser: Omit<CustomUser, 'id'|'avatar_url'|'get_display_name'|'has_usable_password'>;
}

export interface UsersProfileApiKeyRevokeRequest {
    apiKeyRevoke: APIKeyRevoke;
}

export interface UsersProfileAvatarUpdateRequest {
    avatar: Blob;
}

export interface UsersProfileUpdateRequest {
    profileUpdateRequest: ProfileUpdateRequest;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * API endpoint to get recent system activity for admin dashboard.
     */
    async usersAdminActivityRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/activity/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * API endpoint to get recent system activity for admin dashboard.
     */
    async usersAdminActivityRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAdminActivityRetrieveRaw(initOverrides);
    }

    /**
     * API endpoint to get system health status for admin dashboard.
     */
    async usersAdminHealthRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/health/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * API endpoint to get system health status for admin dashboard.
     */
    async usersAdminHealthRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAdminHealthRetrieveRaw(initOverrides);
    }

    /**
     * API endpoint for performing bulk operations on users. Supports: activate, deactivate, make_staff, remove_staff
     */
    async usersAdminUsersBulkActionsCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/bulk-actions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * API endpoint for performing bulk operations on users. Supports: activate, deactivate, make_staff, remove_staff
     */
    async usersAdminUsersBulkActionsCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAdminUsersBulkActionsCreateRaw(initOverrides);
    }

    /**
     * API endpoint for listing and searching users for admin management. Provides filtering, search, and pagination for user administration.
     */
    async usersAdminUsersListRaw(requestParameters: UsersAdminUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedCustomUserList>> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCustomUserListFromJSON(jsonValue));
    }

    /**
     * API endpoint for listing and searching users for admin management. Provides filtering, search, and pagination for user administration.
     */
    async usersAdminUsersList(requestParameters: UsersAdminUsersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedCustomUserList> {
        const response = await this.usersAdminUsersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersPartialUpdateRaw(requestParameters: UsersAdminUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling usersAdminUsersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedCustomUserToJSON(requestParameters['patchedCustomUser']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomUserFromJSON(jsonValue));
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersPartialUpdate(requestParameters: UsersAdminUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomUser> {
        const response = await this.usersAdminUsersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersRetrieveRaw(requestParameters: UsersAdminUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling usersAdminUsersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomUserFromJSON(jsonValue));
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersRetrieve(requestParameters: UsersAdminUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomUser> {
        const response = await this.usersAdminUsersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for user statistics used in admin dashboard.
     */
    async usersAdminUsersStatsRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/stats/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * API endpoint for user statistics used in admin dashboard.
     */
    async usersAdminUsersStatsRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAdminUsersStatsRetrieveRaw(initOverrides);
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersUpdateRaw(requestParameters: UsersAdminUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling usersAdminUsersUpdate().'
            );
        }

        if (requestParameters['customUser'] == null) {
            throw new runtime.RequiredError(
                'customUser',
                'Required parameter "customUser" was null or undefined when calling usersAdminUsersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/admin/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomUserToJSON(requestParameters['customUser']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomUserFromJSON(jsonValue));
    }

    /**
     * API endpoint for retrieving and updating individual user details. Allows admins to modify user permissions and status.
     */
    async usersAdminUsersUpdate(requestParameters: UsersAdminUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomUser> {
        const response = await this.usersAdminUsersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileApiKeyCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIKeyCreated>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/api-keys/create/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIKeyCreatedFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileApiKeyCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIKeyCreated> {
        const response = await this.usersProfileApiKeyCreateRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileApiKeyRevokeRaw(requestParameters: UsersProfileApiKeyRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileAction>> {
        if (requestParameters['apiKeyRevoke'] == null) {
            throw new runtime.RequiredError(
                'apiKeyRevoke',
                'Required parameter "apiKeyRevoke" was null or undefined when calling usersProfileApiKeyRevoke().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/api-keys/revoke/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIKeyRevokeToJSON(requestParameters['apiKeyRevoke']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileActionFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileApiKeyRevoke(requestParameters: UsersProfileApiKeyRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileAction> {
        const response = await this.usersProfileApiKeyRevokeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileApiKeysListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIKeyList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/api-keys/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIKeyListFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileApiKeysList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIKeyList> {
        const response = await this.usersProfileApiKeysListRaw(initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for avatar upload
     */
    async usersProfileAvatarUpdateRaw(requestParameters: UsersProfileAvatarUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AvatarUpdated>> {
        if (requestParameters['avatar'] == null) {
            throw new runtime.RequiredError(
                'avatar',
                'Required parameter "avatar" was null or undefined when calling usersProfileAvatarUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['avatar'] != null) {
            formParams.append('avatar', requestParameters['avatar'] as any);
        }

        const response = await this.request({
            path: `/users/api/profile/upload-avatar/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AvatarUpdatedFromJSON(jsonValue));
    }

    /**
     * API endpoint for avatar upload
     */
    async usersProfileAvatarUpdate(requestParameters: UsersProfileAvatarUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AvatarUpdated> {
        const response = await this.usersProfileAvatarUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileMfaStatusRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MFAStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/2fa-status/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MFAStatusFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileMfaStatusRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MFAStatus> {
        const response = await this.usersProfileMfaStatusRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDetails>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileDetailsFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDetails> {
        const response = await this.usersProfileRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersProfileSocialAccountsRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnectedAccounts>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/social-accounts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectedAccountsFromJSON(jsonValue));
    }

    /**
     */
    async usersProfileSocialAccountsRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnectedAccounts> {
        const response = await this.usersProfileSocialAccountsRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update user profile information including name, email, language, and timezone
     * Update user profile
     */
    async usersProfileUpdateRaw(requestParameters: UsersProfileUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileUpdateResponse>> {
        if (requestParameters['profileUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'profileUpdateRequest',
                'Required parameter "profileUpdateRequest" was null or undefined when calling usersProfileUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/users/api/profile/update/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileUpdateRequestToJSON(requestParameters['profileUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Update user profile information including name, email, language, and timezone
     * Update user profile
     */
    async usersProfileUpdate(requestParameters: UsersProfileUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileUpdateResponse> {
        const response = await this.usersProfileUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
